import { tr } from '../../i18n/text';
import { useTranslation } from 'react-i18next';
import "./button.css";
import { useNavigate } from "react-router-dom";
import { useNumericValidation } from '../numeric_validation/NumericValidation';

export const Button = ({ 
  texto, 
  props_style = "primary", 
  link, 
  params, 
  onClick, 
  className = "", 
  secondary = false,
  disabled = false,
  size = "md",
  type = "button",
  requiresValidNumbers = false,
}) => {
  useTranslation('app');
  const navigate = useNavigate();
  const { hasInvalidNumbers, feedbackId } = useNumericValidation();
  const isDisabled = disabled || (requiresValidNumbers && hasInvalidNumbers);
  
  // Tamanhos responsivos
  const sizes = {
    sm: "py-[2px] px-[8px] h-[32px] text-sm",
    md: "py-2 px-3 min-h-[44px] h-auto text-sm md:px-4 lg:px-6",
    lg: "py-[4px] px-[16px] h-[48px] text-base"
  };

  // Estilos baseados no sistema de design
  const getButtonStyles = () => {
    if (isDisabled) {
      return "bg-gray-200 text-gray-700 cursor-not-allowed";
    }
    
    if (secondary) {
      return "bg-white text-action-foreground border-2 border-control hover:bg-primary-50 active:bg-primary-100";
    }
    
    switch (props_style) {
      case "variant-2":
        return "bg-white text-primary-700 border border-primary-700 hover:bg-primary-50 active:bg-primary-100";
      case "success":
        return "bg-success-action text-white hover:bg-success-action-hover active:bg-success-action-hover";
      case "warning":
        return "bg-warning-500 text-gray-900 border border-warning-700 hover:bg-warning-600 active:bg-warning-600";
      case "embrapa":
        return "bg-[var(--embrapa-green)] text-white hover:bg-success-action-hover active:bg-success-action-hover";
      default: // primary
        return "bg-action text-white hover:bg-action-hover active:bg-action-active";
    }
  };

  return (
    <button
      type={type}
      className={`
        app-action-button flex items-center justify-center relative font-medium
        rounded-lg motion-interactive transform-gpu
        focus:outline-none focus:ring-2 focus:ring-focus focus:ring-offset-2
        disabled:cursor-not-allowed disabled:transform-none disabled:shadow-sm
        ${sizes[size]}
        ${getButtonStyles()}
        ${className}
      `}
      onClick={type === "submit" ? onClick : () => !isDisabled && (onClick ? onClick() : navigate(link, { state: params }))}
      disabled={isDisabled}
      aria-describedby={requiresValidNumbers && hasInvalidNumbers ? feedbackId : undefined}
    >
      <span className="app-action-button__label font-poppins tracking-[0] text-center">
        {tr(texto)}
      </span>
    </button>
  );
};
